<template>
  <div>
    <div @click="routerTo()" id="tb4" style="width: 100%; height: 350px"></div>
  </div>
</template>

<script>
export default {
  props: ["kfxq", "isTrue"],
  data() {
    return {};
  },
  watch: {
    isTrue(val) {
      if (val == true) {
        this.getJrqk();
      }
    },
  },
  methods: {
    routerTo() {
      this.$router.push({ path: "/index/apartment/customerInformation/customerRoom" });
    },
    getJrqk() {
      let myChart = this.echarts.init(document.getElementById("tb4"), "dark");
      setTimeout(() => {
        this.$http.get("/api/roomManage/countRoom").then((res) => {
          console.log("客房数", res);
          this.sum = res.data.data.sum;
          this.free = res.data.data.free;
          this.maintain = res.data.data.maintain;
          this.toBeCheckIn = res.data.data.toBeCheckIn;
          this.checkedIn = res.data.data.checkedIn;

          let data = [
            {
              value: this.free,
              name: "空闲中",
            },
            {
              value: this.maintain,
              name: "维护中",
            },
            {
              value: this.toBeCheckIn,
              name: "待入住",
            },
            {
              value: this.checkedIn,
              name: "已入住",
            },
          ];
          let option = {
            backgroundColor: "#0F0B26",
            title: {
              text: "客房详情",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c}",
            },
            legend: {
              x: "center",
              y: "bottom",
              data: ["待入住", "空闲中", "已入住", "维护中"],
            },
            color: ["#FF6E76", "#58D9F9", "#7CFFB2", "#05C091"],
            series: [
              {
                name: "客房信息",
                type: "pie",
                radius: ["40%", "70%"],
                data: data,
                emphasis: {
                  label: {
                    show: true,
                    fontSize: "20",
                    fontWeight: "bold",
                  },
                },

                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      formatter: "{b} : {c} ",
                    },
                  },
                },
              },
            ],
          };
          myChart.setOption(option);
        });
      }, 100);
    },
  },
};
</script>

<style scoped="scoped"></style>
